import React, { Fragment, useEffect } from "react";
import ScrollToTop from "ScrollToTop";
import Routers from "./Navigation/Routers";
import { setDefaultHeader } from "./utils/httpClient";
import { useDispatch, useSelector } from "react-redux";
import { jwtTokenGenrate } from "./reduxStore/action/authActions";
import MyErrorBoundary from "component/MyErrorBoundary";

function App() {
  const dispatch = useDispatch();
  const loginSelector = useSelector((state) => state.login);

  useEffect(() => {
    if (loginSelector?.response == null) {
      tokenGenrate();
    } else {
      if (loginSelector?.response?.status === 200) {
        setDefaultHeader("token", loginSelector?.response?.token);
      }
    }
  }, [loginSelector]);

  async function tokenGenrate() {
    dispatch(jwtTokenGenrate());
  }
  return (
    <Fragment>
      <MyErrorBoundary>
        <ScrollToTop>
          <Routers />
        </ScrollToTop>
      </MyErrorBoundary>
    </Fragment>
  );
}

export default App;
